import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Categories() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-primary-600 tracking-[0.2em] uppercase font-label mb-3">
            Explore Categories
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            从精品居住到投资洞察，六大核心板块全方位覆盖品质生活所需
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block p-6 rounded-lg bg-background-100 hover:bg-background-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-900 mb-1.5">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium">
                    浏览 {cat.articleCount} 篇文章
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}